import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { createStudentUser } from '@/utils/createStudentUser';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/auth/AuthContext';

export default function CreateStudentUser() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const { isAdmin } = useAuth();

  const handleCreateStudent = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!isAdmin()) {
      toast.error('Only administrators can create student users');
      return;
    }
    
    setIsCreating(true);
    
    try {
      await createStudentUser(email, password);
      toast.success(`Student user ${email} created successfully`);
      setEmail('');
      setPassword('');
    } catch (error: any) {
      toast.error(`Failed to create student user: ${error.message}`);
    } finally {
      setIsCreating(false);
    }
  };

  if (!isAdmin()) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Access Denied</CardTitle>
          <CardDescription>
            You must be an administrator to access this feature.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Create Student User</CardTitle>
        <CardDescription>
          Add a new student account to the system
        </CardDescription>
      </CardHeader>
      <form onSubmit={handleCreateStudent}>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm font-medium">Email</label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="student@example.com"
              required
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-medium">Password</label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Secure password"
              required
              minLength={8}
            />
          </div>
        </CardContent>
        <CardFooter>
          <Button type="submit" disabled={isCreating}>
            {isCreating ? 'Creating...' : 'Create Student User'}
          </Button>
        </CardFooter>
      </form>
    </Card>
  );
}
